const Strings = {
  fxcEndSupportDate: "September 30",

  announceBlogLink: "https://flexacoin.org",

  helpEmail: "mailto:help@flexa.network",
  joinDiscordLink: "https://flexa.network/discord",

  supportedNetworkNames: "Mainnet or the Sepolia testnet",
};

export default Strings;
